"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatherEventEmitter = void 0;
class GatherEventEmitter {
    eventListeners = {};
    lastValues = {};
    addEventListener(event, callback, options = { leading: false }) {
        const listeners = this.eventListeners[event] ?? [];
        listeners.push(callback);
        this.eventListeners[event] = listeners;
        const lastValue = this.lastValues[event];
        if (options.leading && lastValue) {
            callback(...lastValue);
        }
        return () => this.removeEventListener(event, callback);
    }
    removeEventListener(event, callback) {
        const listeners = this.eventListeners[event];
        if (listeners) {
            this.eventListeners[event] = listeners.filter((f) => f !== callback);
        }
    }
    publishEvent(event, ...data) {
        this.lastValues[event] = data;
        const listeners = this.eventListeners[event];
        if (!listeners)
            return;
        for (let i = 0; i < listeners.length; i++) {
            try {
                listeners[i]?.(...data);
            }
            catch (error) {
                console.error(error);
            }
        }
    }
}
exports.GatherEventEmitter = GatherEventEmitter;
//# sourceMappingURL=GatherEventEmitter.js.map